import { useDispatch, useSelector } from "react-redux";
import { authenticate } from "store/Auth/actions";
import i18n from "i18n";
import "./style.scss";

const LangSwitcher = () => {
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const isAr = (AuthData?.lang || i18n.language) === "ar";

	const toggle = () => {
		const newLang = isAr ? "en" : "ar";
		i18n.changeLanguage(newLang);
		localStorage.setItem("vr_lang", newLang);
		document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
		document.documentElement.lang = newLang;
		dispatch(authenticate({ ...AuthData, lang: newLang }));
	};

	return (
		<button className="lang-switcher-btn" onClick={toggle} type="button">
			{isAr ? "EN" : "ع"}
		</button>
	);
};

export default LangSwitcher;
